<template lang="pug">
#base-modal-visualizar-extrato-consultas
    el-dialog(:width='width', :visible='show', @close='closeDialog()')
        template(slot='title')
            .dialog-header
                | {{ title }}
        .modal-container(v-loading='isLoading')
            .modal-container-inner-filtros
                .filtro-tipo-consulta
                    p.title
                        | {{ $t('mensagens.preAnaliseCredito.selecioneTIpoDeConsulta') }}
                    el-radio-group.radio-group-container(
                        v-model='tipoConsulta',
                        @change='mudarTipoConsulta'
                    )
                        el-radio.radio-spacing(:label='"TODOS"')
                            | {{ $t('mensagens.preAnaliseCredito.todos') }}
                        el-radio.radio-spacing(:label='"CPF"')
                            | CPF
                        el-radio.radio-spacing(:label='"CNPJ"')
                            | CNPJ
                .filtro-data
                    el-date-picker#mesVigenteExtratoConsulta(
                        v-model='mesVigente',
                        type='month',
                        format='MM/yyyy',
                        value-format='MM/yyyy',
                        :placeholder="$t('mensagens.preAnaliseCredito.dataDeContrato')",
                        :picker-options='datePickerOptions'
                        @change='mudarMesVigenteConsulta'
                    )
            .modal-container-inner
                .base-header-historico-labels-valores
                    span.base-header-historico-totalizadores
                        | {{ totalizadores.totalConsultas }}
                    span.base-header-historico-texto
                        | {{ $t('mensagens.preAnaliseCredito.consultas') }}
                .base-header-historico-labels-valores
                    span.base-header-historico-totalizadores
                        | {{ totalizadores.totalConsultasNoMes }}
                    span.base-header-historico-texto
                        | {{ $t('mensagens.preAnaliseCredito.consultasNoMes') }}
                .base-header-historico-labels-valores
                    span.base-header-historico-totalizadores
                        | {{ totalizadores.totalCreditoConsumidoMes }}
                    span.base-header-historico-texto
                        | {{ $t('mensagens.preAnaliseCredito.creditosConsumidosMes') }}

            .modal-container-table
                el-table.table-datas(
                    :data='totalizadores.dadosTabela',
                    height='100%',
                    :default-sort='{ prop: "data", order: "descending" }',
                    style='width: 100%; height: 100%',
                    row-key='idTemporario'
                    :expand-row-keys='[1]'
                )
                    el-table-column(
                        :label="$t('mensagens.preAnaliseCredito.labels.dia')",
                        prop='data',
                        :formatter='converterDataParaDiaMesEmTexto',
                        align='left',
                        sortable,
                        min-width='190px'
                    )
                    el-table-column(
                        :label="$t('mensagens.preAnaliseCredito.labels.consultas')",
                        prop='totalConsultasDia',
                        align='left',
                        sortable,
                        min-width='100px'
                    )
                    el-table-column(
                        :label="$t('mensagens.preAnaliseCredito.labels.consumoDeCredito')",
                        prop='totalCreditoConsumidoDia',
                        align='left',
                        sortable,
                        min-width='120px'
                    )
                    el-table-column(type='expand')
                        template(slot-scope='props')
                            el-descriptions.descricao-item-tabela(
                                :size='"mini"',
                                :column='1',
                                direction='vertical'
                            )
                                el-descriptions-item.has-colon-not(
                                    v-if='props.row.detalhes.geral.length > 0',
                                    :label="$t('mensagens.preAnaliseCredito.labels.geral')"
                                )
                                    div(
                                        v-for='(item, index) in props.row.detalhes.geral'
                                    )
                                        span.item-tabela-container
                                            .item-tabela
                                                span.item-tabela-data {{ mxFormatarDataMes(item.dataConsulta) }}
                                                span.item-tabela-texto {{ mxFormatarHora(item.dataConsulta) }}
                                                span.item-tabela-texto {{ numeralStringFormatToDocumento(item.documento) }}
                                            .total-item {{ item.creditoConsumido }}
                                el-descriptions-item.has-colon-not(
                                    v-else,
                                    :label="$t('mensagens.preAnaliseCredito.labels.geral')"
                                )
                                    span.item-tabela-container
                                        .item-tabela
                                            span.item-tabela-texto Nenhum registro encontrado
                                el-descriptions-item.has-colon-not(label='')
                                    el-divider
                                el-descriptions-item.has-colon-not(
                                    v-if='props.row.detalhes.processosJudiciais.length > 0',
                                    :label="$t('mensagens.preAnaliseCredito.labels.processosJudiciais')"
                                )
                                    div(
                                        v-for='(item, index) in props.row.detalhes.processosJudiciais'
                                    )
                                        span.item-tabela-container
                                            .item-tabela
                                                span.item-tabela-data {{ mxFormatarDataMes(item.dataConsulta) }}
                                                span.item-tabela-texto {{ mxFormatarHora(item.dataConsulta) }}
                                                span.item-tabela-texto {{ numeralStringFormatToDocumento(item.documento) }}
                                            .total-item {{ item.creditoConsumido }}
                                el-descriptions-item.has-colon-not(
                                    v-else,
                                    :label="$t('mensagens.preAnaliseCredito.labels.processosJudiciais')"
                                )
                                    span.item-tabela-container
                                        .item-tabela
                                            span.item-tabela-texto {{ $t('mensagens.preAnaliseCredito.nenhumRegistroEncontrado') }}

            el-divider.custom-divider
        .dialog-footer(slot='footer', v-if='mostrarBotaoFechar')
        .dialog-footer-buttons(slot='footer', v-if='mostrarBotaoFechar')
            BaseButton.cancel-button(type='outline', @click='closeDialog()') {{ $t('mensagens.comuns.cancelar') }}
            BaseButton(
                type='primary',
                v-if='mostrarBotaoFechar',
                @click='closeDialog()'
            ) {{ $t('mensagens.comuns.fechar') }}
</template>

<script>
import preAnaliseServiceMixin from '@/mixins/PreAnaliseCreditoMixin';
import Formatters from '@/utils/formatters';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'BaseModalVisualizarExtratoConsultas',
    components: {
        BaseButton
    },
    mixins: [preAnaliseServiceMixin],
    props: {
        show: {
            type: Boolean,
            default: false,
            required: true
        },
        title: {
            type: String,
            default: 'Informações',
            required: false
        },
        width: {
            type: String,
            default: '500px'
        },
        mostrarBotaoFechar: {
            type: Boolean,
            default: true
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        totalizadores: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            tipoConsulta: 'TODOS',
            dataDefault: this.mxGetMesAtual(),
            mesVigente: new Date(),
            datePickerOptions: {}
        };
    },
    watch: {
        totalizadores: function () {
            if (this.totalizadores.primeiroRegistro) {
                let primeiroRegistro = this.dataFormatadaAmericana(this.totalizadores.primeiroRegistro);
                this.datePickerOptions = {
                    disabledDate(date) {
                        return date < primeiroRegistro;
                    }
                };
            }
        }
    },
    methods: {
        closeDialog() {
            this.tipoConsulta = 'TODOS';
            this.mesVigente = new Date();
            this.$emit('closeDialog');
        },
        mudarTipoConsulta(event) {
            this.tipoConsulta = event;
            this.$emit('mudarTipoConsulta', event);
        },
        mudarMesVigenteConsulta(event) {
            this.mesVigente = event;
            this.$emit('mudarMesVigenteConsulta', event);
        },
        numeralStringFormatToDocumento(cpfCnpj) {
            return Formatters.numeralStringFormatToDocumento(cpfCnpj);
        },
        converterDataParaDiaMesEmTexto(row, column, dataString, index) {
            const [dia, mes] = dataString.split('/');

            const meses = [
                this.$t('constantes.meses.janeiro'),
                this.$t('constantes.meses.fevereiro'),
                this.$t('constantes.meses.marco'),
                this.$t('constantes.meses.abril'),
                this.$t('constantes.meses.maio'),
                this.$t('constantes.meses.junho'),
                this.$t('constantes.meses.julho'),
                this.$t('constantes.meses.agosto'),
                this.$t('constantes.meses.setembro'),
                this.$t('constantes.meses.outubro'),
                this.$t('constantes.meses.novembro'),
                this.$t('constantes.meses.dezembro')
            ];

            const nomeMes = meses[parseInt(mes) - 1];
            const dataFormatada = `${parseInt(dia)} de ${nomeMes}`;

            return dataFormatada;
        },
        dataFormatadaAmericana(data) {
            if (data && data.length > 0) {
                let dataString = data.split('/');
                let dia = dataString[0];
                let mes = dataString[1];
                let ano = dataString[2];
                return new Date(ano, mes - 1, dia);
            }
        }
    }
};
</script>

<style lang="scss">
#base-modal-visualizar-extrato-consultas {
    font-family: 'Roboto', 'sans serif';

    .dialog-header {
        background-color: #e9e9e9;
        color: var(--primary);
        padding: 15px;
        margin: -20px -20px 0px -20px;
        font-size: 18px;
        font-weight: 600;
        border-radius: 5px, 5px, 0px, 0px;
        box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.2);
    }

    .el-dialog__footer {
        margin-top: 0px;
        text-align: right;
    }

    .cancel-button {
        border: 1px solid var(--primary) !important;
        color: var(--primary) !important;
        opacity: 0;
        pointer-events: none;
    }

    .dialog-footer-buttons {
        margin-top: 0px;
        text-align: right;
        display: flex;
        justify-content: space-between;
    }

    .el-dialog__body {
        min-height: 600px;
        max-height: 700px;
        padding: 15px;
    }

    .custom-divider {
        margin-bottom: -5px;
        margin-top: 15px;
    }

    .radio-group-container {
        max-width: 250px;
        height: 10px;
        display: flex;
        justify-content: space-between;
    }

    .modal-container {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
    }

    .modal-container-inner-filtros {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-end;
        height: 40px;

        .title {
            margin-bottom: 0.5rem;
            font-size: 14px;
            font-weight: 400;
            line-height: 17px;
            letter-spacing: 0em;
            text-align: left;
            color: var(--primary);
        }

        .filtro-tipo-consulta {
            min-width: 50%;
            height: 40px;
        }

        .filtro-data {
            min-width: 26%;
            height: 40px;
            margin-bottom: -2px;

            .el-date-editor.el-input,
            .el-date-editor.el-input__inner {
                width: 208px !important;
            }
        }
    }

    .modal-container-inner {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-end;
        margin-top: 20px;
        gap: 5px;

        .title {
            margin-bottom: 0.5rem;
        }

        .base-header-historico-labels-valores {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            align-items: center;
            align-content: normal;
            min-width: 208px;
            height: 77px;
            border: 1px solid #e4e7ed;
            border-radius: 5px;

            .base-header-historico-texto {
                font-size: 14px;
                font-weight: 500;
                line-height: 16px;
                letter-spacing: 0em;
                text-align: left;
            }

            .base-header-historico-totalizadores {
                font-size: 18px;
                font-weight: 500;
                line-height: 21px;
                letter-spacing: 0em;
                text-align: left;
                margin-top: 1px;
                color: var(--primary);
            }
        }
    }

    .modal-container-table {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 20px;

        .table-datas {
            height: 100%;
            width: 100%;
            min-height: 40vh;

            .action-button {
                cursor: pointer;
            }
        }

        .el-table__body-wrapper.is-scrolling-none {
            height: 342px !important;
        }
        > table
        > tbody
        > tr
        > td.el-table__expanded-cell {
            .el-descriptions-row {
                padding: 10px;
                background: #f3f3f3;
            }
        }

        .el-table {
            height: 100%;

            .descricao-item-tabela {
                margin-left: 10px;
                margin-right: 10px;
                padding: 15px;
                overflow-y: auto;
                background-color: #f3f3f3;
                border-radius: 5px;

                .el-descriptions-row {
                    background: #f3f3f3 !important;
                }

                .item-tabela-container {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;

                    .item-tabela {
                        display: flex;
                        flex-direction: row;
                        margin-bottom: 5px;
                        gap: 15px;

                        .item-tabela-data {
                            font-size: 14px;
                            font-weight: 500;
                            line-height: 22px;
                            letter-spacing: 0px;
                            text-align: left;
                            color: #3b3b3b;
                        }

                        .item-tabela-texto {
                            font-size: 14px;
                            font-weight: 400;
                            line-height: 22px;
                            letter-spacing: 0px;
                            text-align: left;
                            color: #686868;
                        }
                    }

                    .total-item {
                        font-size: 14px;
                        font-weight: 500;
                        line-height: 22px;
                        letter-spacing: 0px;
                        text-align: left;
                        color: #ff0000;
                    }
                }
            }

            .el-table__expand-icon {
                height: 24px;
                width: 24px;
                margin-bottom: 10px;
            }

            .el-table__expand-icon > .el-icon {
                color: #3b3b3b;
                font-weight: 700;
                font-size: 16px;
            }

            thead {
                color: var(--primary);
                font-size: 16px;
                font-weight: 500;
                line-height: 18.75px;
            }

            .el-descriptions-row {
                .el-descriptions-item__label {
                    color: var(--primary);
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 18.75px;
                }

                .el-divider {
                    margin: 5px 0 15px 0;
                }
            }

            .el-descriptions-item__label.has-colon::after {
                content: '';
            }

            .el-table__body-wrapper.is-scrolling-none
            > table
            > tbody
            .el-table__row.expanded
            td {
                border-bottom: none;
            }
        }
    }
}
</style>
